<template>
    <b-container fluid>
        <!-- Loading spinner -->
        <div v-if="dataLoadingInStoreStatus"  class="text-center" style="font-size:20px; font-weight:bold; width:300px; 
            text-align:center; justify-content:center; margin:auto; background-color:#8c8c8c;  border: 1px solid #8c8c8c;
            border-radius:5px">
            <div style="padding-top:20px; color:#fff;"> Loading Beverages </div>
            <br>
            <div style="padding-bottom:10px">
                <b-spinner style="padding-bottom:10px" large variant="light" label="Text Centered">Loading</b-spinner>
            </div>
        </div>
        <!-- Sorting spinner -->
        <transition name="fade">
        <div v-if="showAnimation" class="loading">
            <p>{{animationTitle}}</p>
        </div>
        </transition>
        <!------------------>
        <!-- Cart sidebar -->
        <!------------------>
        <div>
            <b-sidebar id="sidebar-cart" title="Cart" right shadow v-model="showSideBar" backdrop-variant="dark" backdrop>
                <Cartsidebar  />
            </b-sidebar>
        </div>

    <b-row>
    <!-- Beers column -->
    <b-col>
    <!-- Top ribbon with icons -->        
        <b-row style="margin-top:5px"  v-if='shouldShowSearch'>
            <b-col>
                <!--
                <b-button-group>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/new_button.png"   @click="sortNewest()"  style="margin-left:20px; margin-bottom:20px; cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/popular_button.png"  @click="sortPopular()" style="margin-left:20px; margin-bottom:20px; cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/IPA_button.png"  @click="filterStyle('IPA')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/doubleIPA_button.png"   @click="filterStyle('Double IPA')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/hazyIPA_button.png"  @click="filterStyle('Hazy')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/PALEALE_button.png"  @click="filterStyle('Pale Ale')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/pilsner_button-rev.png"   @click="filterStyle('Pilsner')" style="margin-left:20px; margin-bottom:20px; cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/lager_button.png"   @click="filterStyle('Lager')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/SOUR_button.png"  @click="filterStyle('Sour')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/Saison_button.png"  @click="filterStyle('Saison')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/amber_button.png"  @click="filterStyle('Amber')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/stout_button.png"  @click="filterStyle('Stout')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/seltzer_button.png"  @click="filterStyle('Seltzer')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/kombucha_button.png" @click="filterStyle('Kombucha')"  style="margin-left:20px;  margin-bottom:20px; cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/cider_button.png"  @click="filterStyle('Cider')" style="margin-left:20px;  margin-bottom:20px; cursor:pointer"/></b-button>
                    <b-button variant="light"><img height="60px" src="../assets/catbuttons/wine_button-REV.png" @click="filterStyle('Wine')"  style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/></b-button>
                </b-button-group>
                -->

                <img height="60px" src="../assets/catbuttons/new_button.png"   @click="sortNewest()"  style="margin-left:20px; margin-bottom:20px; cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/popular_button.png"  @click="sortPopular()" style="margin-left:20px; margin-bottom:20px; cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/IPA_button.png"  @click="filterStyle('IPA')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/doubleIPA_button.png"   @click="filterStyle('Double IPA')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/pilsner_button-rev.png"   @click="filterStyle('Pilsner')" style="margin-left:20px; margin-bottom:20px; cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/lager_button.png"   @click="filterStyle('Lager')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/hazyIPA_button.png"  @click="filterStyle('Hazy')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/PALEALE_button.png"  @click="filterStyle('Pale Ale')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/SOUR_button.png"  @click="filterStyle('Sour')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                
                <img height="60px" src="../assets/catbuttons/Saison_button.png"  @click="filterStyle('Saison')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/amber_button.png"  @click="filterStyle('Amber')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/stout_button.png"  @click="filterStyle('Stout')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/seltzer_button.png"  @click="filterStyle('Seltzer')" style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/kombucha_button.png" @click="filterStyle('Kombucha')"  style="margin-left:20px;  margin-bottom:20px; cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/cider_button.png"  @click="filterStyle('Cider')" style="margin-left:20px;  margin-bottom:20px; cursor:pointer"/>
                <img height="60px" src="../assets/catbuttons/wine_button-REV.png" @click="filterStyle('Wine')"  style="margin-left:20px; margin-bottom:20px;  cursor:pointer"/>
            </b-col>
        </b-row>
        
    <!-- Search and drop down. Do not show when shopwing brewery profile -->
    <b-row  v-if='shouldShowSearch'>
        <b-col>
            <div class="mt-1">

                <!-- Containers drop down -->
                <b-dropdown id="dropdown-form" :text="getContainerButtonText" ref="dropdown" class="m-md-2" style="margin-right:10px; margin-bottom:5px;" variant="warning"  size="m">
                    <b-dropdown-header id="dropdown-header-label" style=" margin-bottom:15px">
                        <h6 style="margin-right:50px; margin-bottom:5px">Select Containers To Show</h6>
                    </b-dropdown-header>
                    <!-- Keg sizes -->
                    <b-form-checkbox style="margin-left:20px"
                                id="checkbox-barrels1"
                                v-model="showBarrel1"
                                name="checkbox-barrels1"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/barrel.png"/>  <span style="margin-left:20px">1/2 Barrel, 15.5 Gal</span>
                    </b-form-checkbox>
                    <b-form-checkbox style="margin-left:20px"
                                id="checkbox-barrels2"
                                v-model="showBarrel2"
                                name="checkbox-barrels2"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/barrel.png"/>  <span style="margin-left:20px">13.2 Gal, 50L</span>
                    </b-form-checkbox>
                    <b-form-checkbox style="margin-left:20px"
                                id="checkbox-barrels3"
                                v-model="showBarrel3"
                                name="checkbox-barrels3"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/barrel.png"/>  <span style="margin-left:20px">1/4th Barrel, 7.75 Gal</span>
                    </b-form-checkbox>
                    <b-form-checkbox style="margin-left:20px"
                                id="checkbox-barrels4"
                                v-model="showBarrel4"
                                name="checkbox-barrels4"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/barrel.png"/>  <span style="margin-left:20px">1/6th Barrel, 5.16 Gal</span>
                    </b-form-checkbox>


                    <!-- Show cans -->
                    <b-form-checkbox  style="margin-left:20px"
                                id="checkbox-cans"
                                v-model="showCans"
                                name="checkbox-cans"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/can2.png"/>  <span style="margin-left:20px">Cans</span>
                    </b-form-checkbox>
                    <!-- Show bottles -->
                    <b-form-checkbox  style="margin-left:20px"
                                id="checkbox-bottles"
                                v-model="showBottles"
                                name="checkbox-bottles"
                                value="yes"
                                unchecked-value="no"
                                >
                                <img width="20px" src="../assets/bottle.png"/>  <span style="margin-left:20px">Bottles</span>
                    </b-form-checkbox>
                </b-dropdown>

                <!-- Breweries modal -->
                <b-button  size="m"  v-if='!showBrewerList&&shouldShowSearch' class="m-md-2"  style="margin-right:10px; margin-bottom:5px" variant="warning" v-b-modal = "'modal-brewers' + shouldShowSearch"  v-b-tooltip.hover.right title="Show list of brewers that deliver to your county">Breweries</b-button>
                <b-modal no-fade  scrollable size="l" :id= "'modal-brewers' + shouldShowSearch" title="Brewers" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                    <div v-for="(item,index) in getSortedBrewersList" :key="item.uid+index">
                        <div  v-if="item.isbrewer==1" >
                            <hr>
                            <a @click="viewBrewerProfile(item)"><h6>{{item.company}}</h6></a>
                        </div>
                    </div>
                </b-modal>

                <!-- Beer filter modal -->
                <b-button  size="m"   v-if='!showBrewerList&&shouldShowSearch' class="m-md-2"  style="margin-right:10px; margin-bottom:5px" variant="warning" v-b-modal = "'modal-filters' + shouldShowSearch">
                    More Filters <font-awesome-icon icon="filter" />
                </b-button>
                <b-modal no-fade  scrollable size="l" :id= "'modal-filters' + shouldShowSearch" title="Filter Beers" ok-title="Apply Filters"
                    @ok="userWantsToFilter()">
                    <filterbeers ref="beerfilter" :beersList="everyAvailableBeer" :applyFilters="pressedApplyFilters"/>
                    
                </b-modal>
                
            </div>
        </b-col>
    </b-row>
        <!-- Search input and button -->
        <b-row id="searchbox">
        <b-col  v-if='!showBrewerList&&shouldShowSearch' style='margin-top:10px;'>                    
            <b-button-toolbar>
                <div class="input-group">
                    <b-form-input size="m" type="text"  v-model="searchPhrase" class="form-control" placeholder="Brewery, Name, Style"   @keyup.enter="searchForPhrase()">
                    </b-form-input>
                    <div class="input-group-append">
                        <b-button size="m" class="btn btn-secondary" type="button" @click="searchForPhrase()" > 
                            <font-awesome-icon icon="search" />
                        </b-button>
                    </div>
                </div>
            </b-button-toolbar>
        </b-col>
        </b-row>
    <hr>
    
    <!-- Close search button -->
    <b-row  v-if='isShowingSearchResults&&shouldShowSearch'>
        <b-col>  
            <label onmouseover="" style="cursor: pointer; font-size:20px; border: 1px solid grey; border-radius:5px; background-color:#f2f2f2"  @click="closeSearchResults()"><span style=" margin-left:15px; margin-right:15px">{{displaySearchPhrase}} <font-awesome-icon icon="times-circle" style="padding-right:5px; font-size:25px"/></span></label>
        </b-col>
    </b-row>

    <!-------------------------------------------------------->
    <!-- Post offering beers carousel -->
    <!-------------------------------------------------------->
    <!--
    <b-row v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch&&getPostOff.length>0'>
        <b-col>
            <h5 style="color:grey">Post Offerings on Kegseeker</h5>
        </b-col>
    </b-row>
        <b-row v-if="windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch&&getPostOff.length>0" style=" border-radius:10px">
        <b-col>
            <carousel :style="getCarouselStyle"  :perPageCustom="[[800, 2],[1000, 3],[1500, 4]]"  :mouse-drag="false" 
            :autoplay="false" :loop="false" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" :paginationEnabled="false"
            paginationActiveColor="#2e5189" paginationColor="#fff">
            
                <template  v-for="(beer, index) in getPostOff"  >
                    <slide :key="index" style="">
                        <beercomponent :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch" :sentFromCarousel='true' :showCartSidebar='showCartSidebar'/>
                    </slide>
                </template>
            </carousel>
        </b-col>
    </b-row>
    -->

    <!-------------------------------------------------------->
    <!-- New beers carousel. This location for UI version 1 -->
    <!-------------------------------------------------------->
    <b-row v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch'>
        <b-col>
            <h5 style="color:grey">New on Kegseeker</h5>
        </b-col>
    </b-row>
    <!-- New beers carousel for large device. This location for UI version 1  -->
        <b-row v-if="windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch" style=" border-radius:10px">
        <b-col>
            <carousel :style="getCarouselStyle"  :perPageCustom="[[800, 2],[1000, 3],[1500, 4]]"  :mouse-drag="false" 
            :autoplay="false" :loop="false" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" :paginationEnabled="false"
            paginationActiveColor="#2e5189" paginationColor="#fff">
            
                <template  v-for="(beer, index) in getNewest"  >
                    <slide :key="index" style="">
                        <beercomponent :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch" :sentFromCarousel='true' :showCartSidebar='showCartSidebar'/>
                    </slide>
                </template>
            </carousel>
        </b-col>
    </b-row>

    <!--
        <b-row v-if="windowWidth<=800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch" class="d-md-block"  style="border-radius:10px">
        <b-col>
            <carousel :perPageCustom="[[550, 1],[750, 3],[1070, 6], [1100, 8]]"  :mouse-drag="true" 
            :autoplay="false" :loop="false" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" :paginationEnabled="false"
            paginationActiveColor="#2e5189" paginationColor="#fff">
            
                <template  v-for="(beer, index) in getNewest"  >
                    <slide :key="index" style="">
                        <beercomponent :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch" :sentFromCarousel='true'  :showCartSidebar='showCartSidebar'/>
                    </slide>
                </template>
            </carousel>
        </b-col>
    </b-row>
    -->
    <hr v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch'>


    <!-------------------------------------------->
    <!-- Popular beers carousel, UI Version = 1 -->
    <!-------------------------------------------->
    <b-row v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch'>
        <b-col>
            <h5 style="color:grey">Popular</h5>
        </b-col>
    </b-row>
    <!-- Popular beers carousel for large device -->
        <b-row v-if="windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch" style="  border-radius:10px">
        <b-col>
            <carousel :style="getCarouselStyle"  :perPageCustom="[[800, 2],[1000, 3],[1500, 4]]"  :mouse-drag="false" 
            :autoplay="false" :loop="false" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" :paginationEnabled="false"
            paginationActiveColor="#2e5189" paginationColor="#fff">
            
                <template  v-for="(beer, index) in getPopular"  >
                    <slide :key="index" style="">
                        <beercomponent :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch" :sentFromCarousel='true'  :showCartSidebar='showCartSidebar'/>
                    </slide>
                </template>
            </carousel>
        </b-col>
    </b-row>
    <!-- Popular beers carousel for small device -->
    <!--
        <b-row v-if="windowWidth<=800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch" class="d-md-block"  style=" border-radius:10px">
        <b-col>
            <carousel :perPageCustom="[[550, 1],[750, 3],[1070, 6], [1100, 8]]"  :mouse-drag="true" 
            :autoplay="false" :loop="false" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" :paginationEnabled="false"
            paginationActiveColor="#2e5189" paginationColor="#fff">
            
                <template  v-for="(beer, index) in getPopular"  >
                    <slide :key="index" style="">
                        <beercomponent :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch"   :sentFromCarousel='true'  :showCartSidebar='showCartSidebar'/>
                    </slide>
                </template>
            </carousel>
        </b-col>
    </b-row>
    -->
    <hr v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch'>

    <!-- Selected containers display -->
    <b-row  v-if='getContainerDisplayText'>
        <b-col>  
            <label onmouseover="" style="cursor: pointer; font-size:15px; border: 1px solid grey; border-radius:5px; background-color:#f2f2f2"  @click="resetContainers()"><span style=" margin-left:15px; margin-right:15px; margin-bottom:20px;">{{getContainerDisplayText}} <font-awesome-icon icon="times-circle" style="padding-right:5px; font-size:25px"/></span></label>
        </b-col>
    </b-row>
        
    <b-row class = 'inputwarning' v-if='noContainerSelected'><h5>Please select at least one container</h5></b-row>

    <!------------------------->
    <!-- Nothing found -->
    <!------------------------->
    <b-row v-if='getDisplayArray.length<=0&&!dataLoadingInStoreStatus'>
        <b-col>
            <h5>Sorry we could not find anything at this time. Please check back, we are constantly adding new beers and breweries.</h5>
        </b-col>
    </b-row>

    <!------------------------->
    <!-- Everything-->
    <!------------------------->
    <b-row v-if='windowWidth>800&&!isShowingSearchResults&&!getContainerDisplayText&&shouldShowSearch'>
        <b-col>
            <h5 style="">Everything on Keg Seeker, {{displayBeerLength}} Beverages</h5>
        </b-col>
    </b-row>
    <!-- Number of beverages found -->
    <!--
    <b-row>
        <b-col>
            <div style="color:green">
            <h6>Found {{displayBeerLength}} Beverages</h6>
            </div>
        </b-col>
    </b-row>
    -->
    
    <!-- Page controls -->
    <b-row v-if="!showBrewerList" id='toppagecontrol'>
        <b-col  sm="9">
            <b-pagination  size="sm"
                v-model="currentPage"
                :total-rows="totalLength"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
            ></b-pagination>
        </b-col>
        <b-col sm="3">
                <b-form-group  label-size="sm" 
                    label-cols-sm="6"
                    label="Per Page"
                    label-align-sm="right"
                    label-for="size"
                    style="width:auto"
                    >
                    <b-form-select size="sm"
                        style="width:auto"
                    id="size"
                    v-model="perPage"
                    :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
        </b-col>
    </b-row>
    
    <!-- Error when adding top cart and no quantity entered -->
    <b-row>
        <b-col>
            <b-modal no-fade size="l" id="modal-quantityexceeds" ok-only title="Error" ok-title="OK">
                {{quantityerrormessage}}   
            </b-modal>
        </b-col>
    </b-row>

    <!-- Retailer -->
    <b-row>
        <beercomponent v-for="beer in getDisplayArray" :beer="beer" :key="beer.id"  :shouldShowSearch="shouldShowSearch" :showCartSidebar='showCartSidebar'/>
    </b-row>


        <b-row>
            <b-pagination size="sm"
                v-model="currentPage"
                :total-rows="totalLength"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                @change="pageChanged"
                ></b-pagination>

        </b-row>
    </b-col>
    </b-row>
    </b-container>
</template>

<script>

/*module.exports = {
  props: ['receiverId']
}*/

    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Sendmessage from './Sendmessage'
    import Beercomponent from './Beercomponent'
    import Cartsidebar from './buyer/Cartsidebar'
    import Filterbeers from './Filterbeers'
    import {fullBeerStylesList} from './Myfunctions'
    import {mainBeerStylesList} from './Myfunctions'
    import { deliveryAgents } from './Myfunctions'
    import { Carousel, Slide } from 'vue-carousel';



export default {
    props: ['everyAvailableBeer', 'shouldShowSearch', 'shouldAllowShopping'],
            components: {
            Sendmessage,
            Beercomponent,
            Filterbeers,
            Cartsidebar,
            Carousel,
            Slide,
        },

        data() {
            return {
                windowHeight: 0,
                windowWidth: 0,
                txt: '',
                showSuccess: false,
                showAnimation: false,
                theMessage:'',
                performingRequest:false,
                showingThread:false,
                showMessageSent: false,
                defaultMessage:'Type your message',
                arrayDefaultMessages:[
                    'Could you please send me some samples',
                ],
                showBrewerList:false,
                sortBrewerAsc:false,
                sortCostAsc:false,
                sortNewsestDesc:false,
                showingSearchResults:false,
                showingSortResults:false,
                showingAllResults:true,
                searchPhrase:'',
                currentPage:1,
                perPage:24,
                totalLength:'',
                quantityerrormessage:'',
                showBarrels:'yes',
                showBarrel1:'yes',
                showBarrel2:'yes',
                showBarrel3:'yes',
                showBarrel4:'yes',
                showCans:'yes',
                showBottles:'yes',
                fullDisplayArray:[],
                animationTitle:"",
                noContainerSelected:false,
                compactMode:false,
                selectedTypeOption:null,
                //displaySearchPhrase:'',
                displayBeerLength:'',

                pageOptions: [
                    { value: '24', text: '25' },
                    { value: '48', text: '50' },
                    { value: '96', text: '100' },
                    { value: '9999999999999', text: 'All' },
                    ],

                typeOptions: [
                    { text: 'Amber Ale', value:'Amber Ale'},
                    { text: 'Belgian', value:'Belgian'},
                    { text: 'Blonde', value: 'Blonde' },
                    { text: 'Brown Ale', value:'Brown Ale'},
                    { text: 'Golden Ale', value: 'Golden Ale' },
                    { text: 'Hefeweizen', value:'Hefeweizen'},
                    { text: 'IPA', value: 'IPA' },
                    { text: 'Lager', value: 'Lager' },
                    { text: 'Pale Ale', value: 'Pale Ale' },
                    { text: 'Pilsner', value: 'Pilsner' },
                    { text: 'Porter', value: 'Porter' },
                    { text: 'Red Ale', value:'Red Ale'},
                    { text: 'Saison', value: 'Saison' },
                    { text: 'Stout', value: 'Stout' },
                    { text: 'Wheat', value:'Wheat'},
                ],
                beersFromBrewer:[], //To show beers from brewer once consumer adds one of them
                showSideBar:false,

                //Length of newBeers
                lengthNewBeers:25,
                lengPopBeers:25,

            }
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'userCart', 'brewersList', 'favoriteBrewersList', 'promotionsEnabled', 
            'dataLoadingInStoreStatus', 'searchBeerList', 'displaySearchPhrase', 'beerFilter', 'uiVersion']),

            //Carousel style
            getCarouselStyle(){
                var style={}
                if(this.windowWidth<400) style.width = (this.windowWidth).toString() + "px"
                else style.width = (this.windowWidth*0.75).toString() + "px"
                //style.backgroundColor="#f2f2f2"
                return style
            },

            //Carousel style for TOP
            getCarouselStyleTop(){
                var style={}
                if(this.windowWidth<400) style.width = (this.windowWidth).toString() + "px"
                else style.width = (this.windowWidth*0.9).toString() + "px"
                //style.backgroundColor="#f2f2f2"
                return style
            },

            //Newest beers
            getNewest(){
                //Shuffle array
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                    return array
                }
                var localSortedList=[]
                function copyObject(obj){
                    var nobj = {};
                    for (let key in obj) {
                        if (typeof obj[key] === 'object'){
                            nobj[key] = copyObject(obj[key]);
                        } else {
                            nobj[key] = obj[key];
                        }
                    }
                    return nobj;
                }
                //Copy beer list
                for (var j=0; j<this.everyAvailableBeer.length; j++){
                    var thisObj=copyObject(this.everyAvailableBeer[j])
                    localSortedList.push(thisObj)
                }


                function compare(a, b) {
                    const costA = parseInt(a.createdTime)
                    const costB = parseInt(b.createdTime)

                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                localSortedList.sort(compare);
                var maxLength = 25
                if (localSortedList.length<25) maxLength = localSortedList.length
                return shuffleArray(localSortedList.slice(0, maxLength))
            },

            //Get popular beers
            getPopular(){
                //Shuffle array
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                    return array
                }
                var localSortedList=[]
                function copyObject(obj){
                    var nobj = {};
                    for (let key in obj) {
                        if (typeof obj[key] === 'object'){
                            nobj[key] = copyObject(obj[key]);
                        } else {
                            nobj[key] = obj[key];
                        }
                    }
                    return nobj;
                }
                //Copy beer list
                for (var j=0; j<this.everyAvailableBeer.length; j++){
                    var thisObj=copyObject(this.everyAvailableBeer[j])
                    localSortedList.push(thisObj)
                }

                function comparePopular(a, b) {
                    var costA = -10
                    var costB = -10
                    if(a.soldCount) costA = a.soldCount
                    if(b.soldCount) costB = b.soldCount
                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                localSortedList.sort(comparePopular);
                var maxLength = 25
                if (localSortedList.length<25) maxLength = localSortedList.length
                return shuffleArray(localSortedList.slice(0, maxLength))

            },

            //Get beers on post offering
            getPostOff(){
                //Shuffle array
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                    return array
                }
                
                function copyObject(obj){
                    var nobj = {};
                    for (let key in obj) {
                        if (typeof obj[key] === 'object'){
                            nobj[key] = copyObject(obj[key]);
                        } else {
                            nobj[key] = obj[key];
                        }
                    }
                    return nobj;
                }

                var localSortedList=[]
                //Copy beer list
                for (var j=0; j<this.everyAvailableBeer.length; j++){
                    if(this.everyAvailableBeer[j].ispostoffering){
                        var thisObj=copyObject(this.everyAvailableBeer[j])
                        localSortedList.push(thisObj)
                    }

                }
                //Shuffle array
                localSortedList=shuffleArray(localSortedList)

                var maxLength = 25
                if (localSortedList.length<25) maxLength = localSortedList.length
                return localSortedList.slice(0, maxLength)

            },

            //For container button, show what is selected
            getContainerButtonText(){
                var containerText="Containers:"
                if (this.showBarrel1=="yes"||this.showBarrel2=="yes"||this.showBarrel3=="yes"||this.showBarrel4=="yes"){
                    containerText=containerText+" Kegs"
                    if (this.showCans=="yes"||this.showBottles=="yes") containerText=containerText+','
                } 
                if (this.showCans=="yes"){
                    containerText=containerText+" Cans"
                    if (this.showBottles=="yes") containerText=containerText+','
                } 
                if (this.showBottles=="yes"){
                    containerText=containerText+" Bottles"
                    
                } 

                return containerText
            },

            //For container display, show what is selected when user selects specific containers
            getContainerDisplayText(){
                var containerText=""

                //If everything is selected, return null
                if (this.showBarrel1=="yes"&&this.showBarrel2=="yes"&&this.showBarrel3=="yes"&&this.showBarrel4=="yes"&&this.showCans=="yes"&&this.showBottles=="yes"){
                    return null
                }

                if (this.showBarrel1=="yes") containerText = containerText + '1/2 Barrel'
                if (this.showBarrel2=="yes") containerText = containerText + ', 13.2 Gal'
                if (this.showBarrel3=="yes") containerText = containerText + ', 1/4th Barrel'
                if (this.showBarrel4=="yes") containerText = containerText + ', 1/6th Barrel'

                if (this.showCans=="yes"){
                    containerText=containerText+", Cans"
                }
                if (this.showBottles=="yes"){
                    containerText=containerText+", Bottles"
                    
                } 
                return containerText
            },

            mainBeerStyles(){  
                return mainBeerStylesList
            },
            isShowingSearchResults(){
                return this.$store.state.showingSearchResults
            },

            //Main display array
            getDisplayArray: function () {

                //Show error if no container selected
                if((this.showBarrel1=='no')&&(this.showBarrel2=='no')&&(this.showBarrel3=='no')&&(this.showBarrel4=='no')&&(this.showCans=='no')&&(this.showBottles=='no')){
                    this.noContainerSelected = true
                }
                else this.noContainerSelected = false

                var displayBeerList=[]
                var beersFilteredByContainer = []
                var listToFilter = []
                var paginatedList = []

                //Search data only when shouldshowsearch, otherwise might be brewery profile view
                if(this.$store.state.showingAllResults&&this.shouldShowSearch) {
                    listToFilter = this.everyAvailableBeer
                }

                else if ((this.$store.state.showingSearchResults||this.showingSortResults)&&this.shouldShowSearch){
                    listToFilter = this.searchBeerList
                }

                else if(!this.shouldShowSearch) listToFilter = this.everyAvailableBeer

                //Show everything if all containers selected
                if((this.showBarrel1=='yes')&&(this.showBarrel2=='yes')&&(this.showBarrel3=='yes')&&(this.showBarrel4=='yes')&&(this.showCans=='yes')&&(this.showBottles=='yes')){
                    beersFilteredByContainer = listToFilter
                }
                
                //All containers not selected. Start container filter
                else{
                    //Filter containers
                    for (var i = 0; i<listToFilter.length; i++){
                        var thisBeer = listToFilter[i]
                        //Check kegs
                        if(this.showBarrel1=='yes'){
                            if(thisBeer.barrel1Size){
                                if(thisBeer.barrel1Size.includes('1/2')) {
                                    beersFilteredByContainer.push(thisBeer)
                                    continue
                                }
                                else if(thisBeer.barrel2Size){
                                    if(thisBeer.barrel2Size.includes('1/2')){
                                        beersFilteredByContainer.push(thisBeer)
                                        continue
                                    }
                                }
                            }
                        }

                        else if(this.showBarrel2=='yes'){
                            if(thisBeer.barrel1Size){
                                if(thisBeer.barrel1Size.includes('13.2')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue
                                } 
                            }
                            else if(thisBeer.barrel2Size){
                                if(thisBeer.barrel2Size.includes('13.2')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue

                                    } 
                                }
                            }

                        else if(this.showBarrel3=='yes'){
                            if(thisBeer.barrel1Size){
                                if(thisBeer.barrel1Size.includes('1/4')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue

                                } 
                            }
                            else if(thisBeer.barrel2Size){
                                if(thisBeer.barrel2Size.includes('1/4')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue

                                } 
                            }
                        }

                        else if(this.showBarrel4=='yes'){
                            if(thisBeer.barrel1Size){
                                if(thisBeer.barrel1Size.includes('1/6')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue

                                } 
                            }
                            else if(thisBeer.barrel2Size){
                                if(thisBeer.barrel2Size.includes('1/6')){
                                    beersFilteredByContainer.push(thisBeer)
                                    continue

                                } 
                            }
                        }

                        //Check cans
                        if((this.showCans=='yes')&&((thisBeer.container=='cans')||thisBeer.ozPerCan)){
                            beersFilteredByContainer.push(thisBeer)
                            continue

                        } 
                        //Check bottles
                        if((this.showBottles=='yes')&&((thisBeer.container=='bottles')||thisBeer.ozPerBottle)){
                            beersFilteredByContainer.push(thisBeer)
                            continue

                        }
                    }
                }

                displayBeerList = beersFilteredByContainer
                this.fullDisplayArray = displayBeerList
                this.totalLength = displayBeerList.length
                this.displayBeerLength = displayBeerList.length

                var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)

                var indexStop = indexStart + parseInt(this.perPage)

                if (indexStop>displayBeerList.length) indexStop = displayBeerList.length
                for (var k = indexStart; k<indexStop; k++){
                    paginatedList.push(displayBeerList[k])
                }

                //console.log(paginatedList)
                return paginatedList

            },

            getSortedBrewersList(){
                var localBrewersList = this.brewersList
                function compare(a, b) {
                    const brewerA = a.company.toLowerCase();
                    const brewerB = b.company.toLowerCase();
                    let comparison = 0;
                    if (brewerA >brewerB) {
                        comparison = 1;
                        } else if (brewerA<brewerB) {
                                    comparison = -1;
                        }
                        return comparison;
                    }
                    localBrewersList.sort(compare);
                    return localBrewersList

            },

        },
        methods:{
            pageChanged(){
                //window.scrollTo(0,0)
                document.getElementById('toppagecontrol').scrollIntoView();
            },
            viewBrewerProfile(brewer){
                var brewerId=brewer.uid
                var distbrewerid=''
                if(brewer.distbrewerid) distbrewerid=brewer.distbrewerid

                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        brewerid:brewer.uid,
                        createdOn: new Date(),
                        state:this.userProfile.state,
                        county:this.userProfile.county,
                    }
                fb.clickedBrewerCollection.add(theData)
                }

                this.$router.push({ path: 'breweryprofile', query: { brewerId: brewerId, distbrewerid:distbrewerid }})
            },


            //Get beers for a style
            getBeersForStyle(style){
                var localSearchList=[]
                //Split string into individual phrases
                var string = style
                string = string.split(" ")
                var stringArray = new Array()
                for(var i =0; i < string.length; i++){
                    stringArray.push(string[i])
                }

                var searchArrayLength = stringArray.length

                //Iterate over search phrase array
                for (var j=0; j<searchArrayLength; j++){
                    
                    var lowerCaseSearchPhrase = stringArray[j].toLowerCase()
                    lowerCaseSearchPhrase = lowerCaseSearchPhrase.replace(/[^a-zA-Z ]/g, "")
                    if(!lowerCaseSearchPhrase||lowerCaseSearchPhrase==''||lowerCaseSearchPhrase==' '||lowerCaseSearchPhrase.length<2)
                        continue
                    //Iterate over all beers
                    for (var i in this.everyAvailableBeer) {
                        var thisBeer = this.everyAvailableBeer[i]
                        var searchTermsFound = 0

                            var thisbeerCat = thisBeer.cat.toLowerCase()
                            var thisbeerName = thisBeer.beerName.toLowerCase()
                            var thisBrewerName = thisBeer.brewer.toLowerCase()
                            var thisBeerDescription = thisBeer.description.toLowerCase()
                            var thisBeerType= thisBeer.type.toLowerCase()
                            if(thisBeer.subType)
                                var thisBeerSubType = thisBeer.subType.toLowerCase()

                            var catSearchResult = -20
                            var beerNameSearchResult = -20
                            var brewerSearchResult  = -20
                            var descriptionSearchResult  = -20
                            var typeSearchResult  = -20
                            var subTypeSearchResult = -20
                            catSearchResult = thisbeerCat.search(lowerCaseSearchPhrase);
                            beerNameSearchResult = thisbeerName.search(lowerCaseSearchPhrase);
                            brewerSearchResult = thisBrewerName.search(lowerCaseSearchPhrase);
                            descriptionSearchResult = thisBeerDescription.search(lowerCaseSearchPhrase);
                            typeSearchResult = thisBeerType.search(lowerCaseSearchPhrase);
                            if(thisBeer.subType) subTypeSearchResult = thisBeerSubType.search(lowerCaseSearchPhrase);

                            //Find how many of the searchphrases were found
                            //Rank name and type as highest

                            if (catSearchResult>-1){
                                searchTermsFound = searchTermsFound + 6
                                //console.log("Found in name " + thisbeerName, lowerCaseSearchPhrase)
                                //console.log("Terms = " + searchTermsFound)
                                //console.log("--------------------------")
                            } 
                            if (beerNameSearchResult>-1){
                                searchTermsFound = searchTermsFound + 4
                                //console.log("Found in name " + thisbeerName, lowerCaseSearchPhrase)
                                //console.log("Terms = " + searchTermsFound)
                                //console.log("--------------------------")
                            } 
                            if (brewerSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1
                            } 
                            if (descriptionSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1

                            } 
                            if (typeSearchResult>-1){
                                searchTermsFound = searchTermsFound + 4
                            } 
                            if (thisBeer.subType&&subTypeSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1
                            } 

                            if ((beerNameSearchResult>-1)||(brewerSearchResult>-1)||(descriptionSearchResult>-1)||(typeSearchResult>-1)||(subTypeSearchResult>-1)){
                                //Check if already exists
                                const searchIndex = localSearchList.findIndex(item => item.id === thisBeer.id);
                                    if (searchIndex !== -1){
                                        if (thisBeer.searchTermsFound) thisBeer.searchTermsFound = thisBeer.searchTermsFound + searchTermsFound
                                        else thisBeer.searchTermsFound =  searchTermsFound
                                        localSearchList.splice(searchIndex, 1, thisBeer)

                                    } 
                                    else {
                                        thisBeer.searchTermsFound =  searchTermsFound
                                        localSearchList.push(thisBeer)
                                    }

                            }
                            function compare(a, b) {
                                const brewerA = a.searchTermsFound;
                                const brewerB = b.searchTermsFound;
                                let comparison = 0;
                                if (brewerA <brewerB) {
                                    comparison = 1;
                                } else if (brewerA>brewerB) {
                                    comparison = -1;
                                }
                                return comparison;
                        }
                        localSearchList.sort(compare);
                    }
                    
                }
                return localSearchList

            },


            searchForPhrase(){
                if(!this.searchPhrase) return

                this.showAnimation = true
                this.animationTitle="Searching"
                setTimeout(() => { this.showAnimation = false }, 1500)

                //Add to search click collection
                if(this.currentUser){
                    //Add to collection
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        searchterm:this.searchPhrase,
                        createdOn: new Date(),
                        state:this.userProfile.state,
                        county:this.userProfile.county,
                    }
                fb.clickedSearchCollection.add(theData)
                }

                this.$store.commit('setSearchBeerList', [])
                var localSearchList=[]
                //this.searchBeerList = []

                this.currentPage = 1

                

                this.showBarrels = 'yes'
                this.showCans= 'yes'
                this.showBottles = 'yes'

                //Split string into individual phrases
                var string = this.searchPhrase
                string = string.split(" ")
                var stringArray = new Array()
                for(var i =0; i < string.length; i++){
                    stringArray.push(string[i])
                }

                var searchArrayLength = stringArray.length
                
                this.closeSearchButtonTitle = 'Close Search'
                //this.displaySearchPhrase = this.searchPhrase
                this.$store.commit('setDisplaySearchPhrase', this.searchPhrase)
                
                this.searchPhrase=''
                this.showingSearchResults=true
                this.$store.commit('setShowingSearchResults', true)
                this.$store.commit('setShowingAllResults', false)
                this.showingAllResults = false

                //Iterate over search phrase array
                for (var j=0; j<searchArrayLength; j++){
                    
                    var lowerCaseSearchPhrase = stringArray[j].toLowerCase()
                    lowerCaseSearchPhrase = lowerCaseSearchPhrase.replace(/[^a-zA-Z ]/g, "")
                    if(!lowerCaseSearchPhrase||lowerCaseSearchPhrase==''||lowerCaseSearchPhrase==' '||lowerCaseSearchPhrase.length<2)
                        continue
                    //console.log("Searching for " + lowerCaseSearchPhrase)

                    //Iterate over all beers
                    for (var i in this.everyAvailableBeer) {
                        var thisBeer = this.everyAvailableBeer[i]
                        var searchTermsFound = 0

                            var thisbeerCat = thisBeer.cat.toLowerCase()
                            var thisbeerName = thisBeer.beerName.toLowerCase()
                            var thisBrewerName = thisBeer.brewer.toLowerCase()
                            var thisBeerDescription = thisBeer.description.toLowerCase()
                            var thisBeerType= thisBeer.type.toLowerCase()
                            if(thisBeer.subType)
                                var thisBeerSubType = thisBeer.subType.toLowerCase()

                            var catSearchResult = -20
                            var beerNameSearchResult = -20
                            var brewerSearchResult  = -20
                            var descriptionSearchResult  = -20
                            var typeSearchResult  = -20
                            var subTypeSearchResult = -20
                            catSearchResult = thisbeerCat.search(lowerCaseSearchPhrase);
                            beerNameSearchResult = thisbeerName.search(lowerCaseSearchPhrase);
                            brewerSearchResult = thisBrewerName.search(lowerCaseSearchPhrase);
                            descriptionSearchResult = thisBeerDescription.search(lowerCaseSearchPhrase);
                            typeSearchResult = thisBeerType.search(lowerCaseSearchPhrase);
                            if(thisBeer.subType) subTypeSearchResult = thisBeerSubType.search(lowerCaseSearchPhrase);

                            //Find how many of the searchphrases were found
                            //Rank name and type as highest

                            if (catSearchResult>-1){
                                searchTermsFound = searchTermsFound + 6
                                //console.log("Found in name " + thisbeerName, lowerCaseSearchPhrase)
                                //console.log("Terms = " + searchTermsFound)
                                //console.log("--------------------------")
                            } 
                            if (beerNameSearchResult>-1){
                                searchTermsFound = searchTermsFound + 4
                                //console.log("Found in name " + thisbeerName, lowerCaseSearchPhrase)
                                //console.log("Terms = " + searchTermsFound)
                                //console.log("--------------------------")
                            } 
                            if (brewerSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1
                                //console.log("Found in brewer " + thisBrewerName, lowerCaseSearchPhrase)
                            } 
                            if (descriptionSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1
                                //console.log("Found in description " + thisBeerDescription, lowerCaseSearchPhrase)

                            } 
                            if (typeSearchResult>-1){
                                searchTermsFound = searchTermsFound + 4
                                //console.log("Found in type " + thisBeerType, lowerCaseSearchPhrase)
                            } 
                            if (thisBeer.subType&&subTypeSearchResult>-1){
                                searchTermsFound = searchTermsFound + 1
                                //console.log("Found in subtype " + thisBeerSubType, lowerCaseSearchPhrase)
                            } 

                            if ((beerNameSearchResult>-1)||(brewerSearchResult>-1)||(descriptionSearchResult>-1)||(typeSearchResult>-1)||(subTypeSearchResult>-1)){
                                //thisBeer.searchTermsFound = searchTermsFound
                                //console.log("Found in beer ")
                                //console.log(thisBeer.beerName)
                                //console.log("-----------------------------------")
                                //Check if already exists
                                const searchIndex = localSearchList.findIndex(item => item.id === thisBeer.id);
                                    if (searchIndex !== -1){
                                        if (thisBeer.searchTermsFound) thisBeer.searchTermsFound = thisBeer.searchTermsFound + searchTermsFound
                                        else thisBeer.searchTermsFound =  searchTermsFound
                                        localSearchList.splice(searchIndex, 1, thisBeer)

                                    } 
                                    else {
                                        thisBeer.searchTermsFound =  searchTermsFound
                                        localSearchList.push(thisBeer)
                                    }

                            }
                            function compare(a, b) {
                                const brewerA = a.searchTermsFound;
                                const brewerB = b.searchTermsFound;
                                let comparison = 0;
                                if (brewerA <brewerB) {
                                    comparison = 1;
                                } else if (brewerA>brewerB) {
                                    comparison = -1;
                                }
                                return comparison;
                        }
                        localSearchList.sort(compare);
                    }
                    this.$store.commit('setSearchBeerList', localSearchList)
                    //Scroll to page controls
                    document.getElementById('searchbox').scrollIntoView();
                    //console.log("Search beer list = ")
                    //console.log(this.searchBeerList)
                }

            },
            closeSearchResults(){
                this.showingSearchResults=false
                this.$store.commit('setShowingSearchResults', false)
                this.$store.commit('setShowingAllResults', true)
                this.showingAllResults = true
                 this.searchPhrase=''

            },
            sortNewest(){
                this.animationTitle="Sorting"
                this.showAnimation = true
                this.currentPage = 1
                
                var localSortedList=[]
                function copyObject(obj){
                    var nobj = {};
                    for (let key in obj) {
                        if (typeof obj[key] === 'object'){
                            nobj[key] = copyObject(obj[key]);
                        } else {
                            nobj[key] = obj[key];
                        }
                    }
                    return nobj;
                }
                //Copy beer list
                for (var j=0; j<this.everyAvailableBeer.length; j++){
                    var thisObj=copyObject(this.everyAvailableBeer[j])
                    localSortedList.push(thisObj)
                }
                setTimeout(() => { this.showAnimation = false }, 1500)

                //this.displaySearchPhrase = "Sorted by Newest"
                this.$store.commit('setDisplaySearchPhrase', "New")
                this.closeSearchButtonTitle = 'Remove Sort'
                this.sortCostAsc=false
                this.sortNewsestDesc=true
                this.sortBrewerAsc=false

                function compare(a, b) {
                    const costA = parseInt(a.createdTime)
                    const costB = parseInt(b.createdTime)

                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                localSortedList.sort(compare);
                this.$store.commit('setSearchBeerList', localSortedList)
                this.showingSortResults = true
                this.$store.commit('setShowingSearchResults', true)
                this.showingSearchResults=false
                this.$store.commit('setShowingAllResults', false)
                this.showingAllResults = false
                this.showBrewerList=false
                document.getElementById('searchbox').scrollIntoView();


            },

            //Sort by popularity
            sortPopular(){
                this.currentPage = 1
                this.showAnimation = true
                this.animationTitle="Sorting by popularity"
                setTimeout(() => { this.showAnimation = false }, 1500)
                var localSortedList=[]
                function copyObject(obj){
                    var nobj = {};
                    for (let key in obj) {
                        if (typeof obj[key] === 'object'){
                            nobj[key] = copyObject(obj[key]);
                        } else {
                            nobj[key] = obj[key];
                        }
                    }
                    return nobj;
                }
                //Copy beer list
                for (var j=0; j<this.everyAvailableBeer.length; j++){
                    var thisObj=copyObject(this.everyAvailableBeer[j])
                    localSortedList.push(thisObj)
                }

                //this.displaySearchPhrase = "Sorted by Popularity"
                this.$store.commit('setDisplaySearchPhrase', "Popular")
                this.closeSearchButtonTitle = 'Remove Sort'
                this.sortCostAsc=false
                this.sortNewsestDesc=true
                this.sortBrewerAsc=false
                //this.$store.commit('setSearchBeerList', this.everyAvailableBeer)
                //this.searchBeerList=this.everyAvailableBeer

                function comparePopular(a, b) {
                    var costA = -10
                    var costB = -10
                    if(a.soldCount) costA = a.soldCount
                    if(b.soldCount) costB = b.soldCount
                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                localSortedList.sort(comparePopular);
                this.$store.commit('setSearchBeerList', localSortedList)
                this.showingSortResults = true
                this.$store.commit('setShowingSearchResults', true)
                this.showingSearchResults=false
                this.$store.commit('setShowingAllResults', false)
                this.showingAllResults = false
                this.showBrewerList=false
                document.getElementById('searchbox').scrollIntoView();


            },
            filterStyle(typePhrase){
                this.$root.$emit('bv::hide::modal',"modalmorestyles")
                this.searchPhrase = typePhrase

                //Add to style click collection
                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        style:typePhrase,
                        createdOn: new Date(),
                        state:this.userProfile.state,
                        county:this.userProfile.county,
                    }
                fb.clickedStyleCollection.add(theData)
                }
                this.searchForPhrase()
            },

            //When user presses apply filter on the filter modal. Tell filter to apply the filter and send the result back
            userWantsToFilter(){
                this.$refs.beerfilter.clickedfilter()
            },
            pressedApplyFilters(filteredBeers){
                
                this.$store.commit('setDisplaySearchPhrase', "Remove Filters")
                //this.displaySearchPhrase="Remove filters"
                this.showAnimation = true
                this.animationTitle="Applying Filters"

                this.closeSearchButtonTitle = 'Remove Filters'
                setTimeout(() => { this.showAnimation = false }, 1500)

                //this.searchBeerList = filteredBeers
                this.$store.commit('setSearchBeerList', filteredBeers)
                this.currentPage = 1
                this.$store.commit('setShowingSearchResults', true)
                this.showingSearchResults=true
                this.$store.commit('setShowingAllResults', false)
                this.showingAllResults = false
            },

            //Reset containers from button
            resetContainers(){
                this.showBarrel1="yes"
                this.showBarrel2="yes"
                this.showBarrel3="yes"
                this.showBarrel4="yes"
                this.showCans="yes"
                this.showBottles="yes"
            },
            markAsFavorite(brewerId, brewer){
                
                fb.usersCollection.doc(this.currentUser.uid).update({
                    favorites: firebase.firestore.FieldValue.arrayUnion(brewerId)
                    });

                    this.$bvToast.toast(brewer + 'Added to favorites', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'success',
                        })

            },
            unFavorite(brewerId, brewer){
                this.$store.dispatch('unFavorite', brewerId)
                this.$bvToast.toast(brewer + 'Removed from favorites', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })

            },
            onResize() {
                this.windowWidth = window.innerWidth
            },

            //Toggle cart sidebar
            showCartSidebar(){
                this.showSideBar=true
            },


        },
    watch: {
        windowWidth(newWidth, oldWidth) {
        this.txt = `it changed to ${newWidth} from ${oldWidth}`;
        }
    },

    mounted() {
        this.windowWidth = window.innerWidth
        this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },

}


</script>

<style scoped>
.table>tbody>tr>td,
.table>tbody>tr>th {
  border-top: none;
}

.ribbontext{
    font-size:12px;
    padding-top:10px;
    padding-bottom:10px;
    cursor:pointer;
}

.imgcontainer {
  position: relative;
  text-align: center;
  color: black;
}

/* Centered text */
.centeredtext {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>